import { DatePipe } from '@angular/common';

export function sendFileToBrowser(data, reportName: string) {
    const datePipe = new DatePipe('en-US');
    const dateString = datePipe.transform(Date.now(), 'yyyyMMdd_HHmmss');
    downloadFile(data, `${reportName}_${dateString}.xlsx`);
}

export function sendCsvToBrowser(csvContent: string, reportName: string) {
    const datePipe = new DatePipe('en-US');
    const dateString = datePipe.transform(Date.now(), 'yyyyMMdd_HHmmss');

    // Prepend a UTF-8 BOM so Excel opens the file with the correct character encoding
    downloadFile('\uFEFF' + csvContent, `${reportName}_${dateString}.csv`, 'text/csv;charset=utf-8;');
}

export function downloadFile(data, reportFileName: string, mimeType: string = 'application/octet-stream') {
    const reportBlob = new Blob([data], { type: mimeType });

    const reportDownloadLink = document.createElement('a');
    reportDownloadLink.href = URL.createObjectURL(reportBlob);
    reportDownloadLink.download = reportFileName;
    reportDownloadLink.click();
}
